import React from 'react';
import { FaTwitter, FaGlobe, FaLinkedinIn } from "react-icons/fa";

const SocialShare = [
    { Social: <FaLinkedinIn />, link: 'https://www.linkedin.com/company/mission-innovation/' },
    { Social: <FaGlobe />, link: 'http://mission-innovation.net/' },
    { Social: <FaTwitter />, link: 'https://twitter.com/MICleanEnergyRD' },
]

const FooterTwo = () => {
    return (
        <div className="footer-style-2 ptb--30 bg_color--6">
            <div className="wrapper plr--50 plr_sm--20">
                <div className="row align-items-center justify-content-between">
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                        <div className="inner">
                            <p className="mb-0">Designed and developed by MI IC7 Resource Unit,</p>
                            <p className="mb-0">Department of Science & Technology, India:</p>
                            <div className="logo text-center text-sm-left mb_sm--20">
                                <a href="https://dst.gov.in/" target="_blank">
                                    <img src="/assets/images/logo/logo-light.png" style={{ maxHeight: '180px' }} alt="Logo images" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                        <div className="inner text-center">
                            <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
                                {SocialShare.map((val, i) => (
                                    <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                        <div className="inner text-lg-right text-center mt_md--20 mt_sm--20">
                            <div className="text">
                                <p className="mb-0">Copyright © 2021 Innovation Community on AHCB.</p>
                                <p className="mb-0"><a href=''></a> Development Credits: Zixwer Pvt. Ltd. </p>
                                <div className="logo text-center text-sm-right mb_sm--20 mt-2">
                                    <a href="https://zixwer.com/" target="_blank">
                                        <img src="/assets/images/logo/zixwer.png" style={{ maxHeight: '30px', height: '30px' }} alt="Logo images" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}
export default FooterTwo;